function SetupA(elem: HTMLAnchorElement) {
    let target = elem.href;
    if (!target) {
        console.log("data-gs-open-in-closable-tab need a href")
    }
    elem.addEventListener("click", (e) => {
        e.preventDefault();
        let target = e.currentTarget as HTMLAnchorElement;
        let href = target.href;
        var wnd = window.open(href);
    }, true);
}

function serialize(form: HTMLFormElement, currentElem) {
    if (form.nodeName != "FORM") {
        console.log("the input form is not a form element");
        return;
    }

    let elem: HTMLElement, fields = [];
    let formElements = form.elements;
    let len = formElements.length;

    function Add(name, value) {
        fields.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }

    for (var i = 0; i < len; i++) {
        elem = formElements[i] as HTMLElement;
        if (!elem["name"] || elem["disabled"]) {
            continue;
        }
        if (elem instanceof HTMLInputElement) {
            if (elem.type == "file") {
                continue;
            }
            if (elem.type == "checkbox" || elem.type == 'radio') {
                if (!elem.checked) {
                    continue;
                }
            }
            Add(elem.name, elem.value)
        } else if (elem instanceof HTMLButtonElement) {
            if (elem !== currentElem) {
                continue;
            }
            Add(elem.name, elem.value)
        } else if (elem instanceof HTMLSelectElement) {
            if (elem.type === 'select-multiple') {
                for (let j = 0; j < elem.options.length; j++) {
                    let option = elem.options[j] as HTMLOptionElement;
                    if (option.selected) {
                        Add(elem.name, option.value);
                    }
                }
            } else {
                Add(elem.name, elem.value);
            }
        } else if (elem instanceof HTMLTextAreaElement) {
            Add(elem.name, elem.value);
        }
    }
    return fields.join('&');
}

function SetupButton(elem: HTMLButtonElement) {
    elem.addEventListener("click", (e) => {
        e.preventDefault();
        let target = e.currentTarget as HTMLButtonElement;
        let queryString = serialize(target.form, target);
        let action = '';
        if (target.formAction) {
            action = target.formAction;
        } else {
            action = target.form.action;
        }
        if (action.indexOf('?') === -1) {
            action += "?";
        }
        action += queryString;
        var wnd = window.open(action);
    }, true);
}

export default function (elem: HTMLElement) {
    if (elem.nodeName === "A") {
        SetupA(<HTMLAnchorElement>elem);
    } else if (elem.nodeName === "BUTTON") {
        SetupButton(<HTMLButtonElement>elem);
    } else {
        console.log("data-gs-toggle='open-in-closable-tab' unknown tag, only a and button are supported")
    }
}